<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-4 w-4"
  >
    <g clip-path="url(#clip0_3821_86)">
      <path
        d="M15 29C22.732 29 29 22.732 29 15C29 7.26801 22.732 1 15 1C7.26801 1 1 7.26801 1 15C1 22.732 7.26801 29 15 29Z"
        stroke="currentColor"
        stroke-width="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_3821_86">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
